export function selectSystemMaintenanceMessage(state) {
  return state.systemMaintenanceMessage;
}

export function selectSystemMaintenanceShowUntilTime(state) {
  return state.systemMaintenanceShowUntilTime;
}

export function selectActiveMaintenanceMessage(state) {
  const msg = state.systemMaintenanceMessage;
  const until = state.systemMaintenanceShowUntilTime;
  if (!msg) return null;
  if (until && new Date() > new Date(until)) return null;
  return msg;
}
